import React, { useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Top100Players from './Top100Players';
import Top100JuniorPlayers from './Top100JuniorPlayers';
import Top100WomenPlayers from './Top100WomenPlayers';
import Top100GirlsPlayers from './Top100GirlsPlayers';
import TopDiffPlayers from './TopDiffPlayers';
import Top100BlitzPlayers from './Top100BlitzPlayers';
import Top100RapidPlayers from './Top100RapidPlayers';


export default function BasicTabs() {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isOrganizer, setIsOrganizer] = useState(false);
    const [currentTabIndex, setCurrentTabIndex] = useState(0);
    const handleTabChange = (e, tabIndex) => {
        setCurrentTabIndex(tabIndex);
    };

    useEffect(() => {
        async function fetchData() {
            var user = await authService.getUser();

            if (user != null) {
                if (user.sub.includes("Affiliate")) {
                    setIsOrganizer(true);
                }
                var role = user.role;
                if (role.includes("Administrators"))
                    setIsAdmin(true);
            }
        }
        fetchData();
    }, []);

    return (
        <Box sx={{ width: '100%', mt: 2, mb: 1, }}>
            <AppBar position="static">
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={currentTabIndex} onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="Top Chess Players"
                    textColor="inherit"
                    indicatorColor="secondary"
                >
                    <Tab label="Top 100" />
                    <Tab label="Top 100 Women" />
                    <Tab label="Top 100 Junior" />
                    <Tab label="Top 100 Girl" />
                    <Tab label="Top 100 Blitz" />
                    <Tab label="Top 100 Rapid" />
                    { (isAdmin || isOrganizer) &&
                        <Tab label="Top Rating Diff" />
                    }
                    </Tabs>
                </Box>
            </AppBar>
            

            {currentTabIndex === 0 && (
                    <Top100Players/>
            )}
            {currentTabIndex === 1 && (
                <Top100WomenPlayers/>
            )}
            {currentTabIndex === 2 && (
                <Top100JuniorPlayers/>
            )}
            {currentTabIndex === 3 && (
                <Top100GirlsPlayers />
            )}
            {currentTabIndex === 4 && (
                <Top100BlitzPlayers />
            )}
            {currentTabIndex === 5 && (
                <Top100RapidPlayers />
            )}
            {currentTabIndex === 6 && (isAdmin || isOrganizer) &&
                <TopDiffPlayers />
            }
        </Box>
    );
}
